import type { ReactNode } from 'react'

export type TomEstado = 'neutro' | 'info' | 'sucesso' | 'alerta' | 'perigo'

export interface ItemEstado {
  id: string
  /** O que o valor significa. Lido por leitor de tela junto com o valor. */
  rotulo: string
  valor: ReactNode
  /** Ícone obrigatório quando o item tem tom: cor sozinha não carrega informação. */
  icone?: ReactNode
  tom?: TomEstado
  /**
   * Item que pode encolher e reticenciar em vez de sair pela borda. É para o
   * texto longo da faixa — a leitura do gesto na oficina —, que é justamente o
   * retorno que precisa ser lido sem rolar a barra.
   */
  flexivel?: boolean
  /** Texto completo, quando o valor pode aparecer reticenciado. */
  titulo?: string
}

interface Props {
  itens: readonly ItemEstado[]
}

/**
 * Faixa fina de estado, no rodapé do workspace.
 *
 * Responde de relance: que módulo é este, o que está selecionado, que ferramenta
 * está ativa, a simulação está rodando. São perguntas que antes só tinham
 * resposta abrindo um grupo da ribbon.
 *
 * Nenhum item se apoia só na cor — cada tom vem acompanhado de ícone e de texto,
 * porque a informação precisa sobreviver em escala de cinza.
 */
export function BarraEstado({ itens }: Props) {
  if (itens.length === 0) return null

  return (
    <div className="barra-estado" role="status" aria-label="Estado do ambiente">
      {itens.map((item) => (
        <span
          key={item.id}
          className={`barra-estado__item barra-estado__item--${item.tom ?? 'neutro'}${
            item.flexivel ? ' barra-estado__item--flexivel' : ''
          }`}
          title={item.titulo}
          data-estado={item.id}
        >
          {item.icone}
          <span className="barra-estado__rotulo">{item.rotulo}</span>
          <strong className="barra-estado__valor">{item.valor}</strong>
        </span>
      ))}
    </div>
  )
}
